import { IPlacesServiceContext } from "context/GoogleServicesContextProvider";
import { createContext } from "react";

export const PlacesServiceContext = createContext({} as IPlacesServiceContext);
